import { useTranslation } from 'react-i18next';

export default function useLang() {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  function pick(doc, field) {
    if (!doc) return '';
    if (lang === 'fr') {
      var frVal = doc[field + '_fr'];
      // Only use the French value if it's a non-empty string
      // Arrays (like highlights_fr) should be handled directly, not through pick()
      if (frVal && typeof frVal === 'string' && frVal.trim()) return frVal;
    }
    var val = doc[field];
    return val !== undefined && val !== null ? val : '';
  }

  // Separate helper for array fields like highlights
  function pickArray(doc, field) {
    if (!doc) return [];
    if (lang === 'fr') {
      var frArr = doc[field + '_fr'];
      if (frArr && Array.isArray(frArr) && frArr.length > 0) return frArr;
    }
    return doc[field] || [];
  }

  return { lang, pick, pickArray };
}